<template>
  <div class="double10 text-NotoSansLight pink-light">
    <div class="main w-full mx-auto max-w-7xl">
      <!-- banner -->
      <a class="banner w-full block">
        <img src="~@/assets/images/double10_2021/top.png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
        <img src="~@/assets/images/double10_2021/banner_m.png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
      </a>
      <!-- 各刊雜誌介紹label -->
      <div class="intro-img pink">
        <img src="~@/assets/images/double10_2021/C1_02.png" class="object-contain h-auto mx-auto w-1/2 md:w-auto">
      </div>
      <!-- 雜誌列表 -->
      <div class="mag-items pink-light p-2 md:px-10 text-gray">
        <ul class="list">
          <li class="flex p-2" v-for="(item, index) in magazine" :key="index">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="w-full block">
              <div class="award px-1 flex flex-col justify-end" :class="{ textCenter: item.award.length < 2 }">
                <p class="text-pink font-semibold tracking-wider" v-for="(child, idx) in item.award" :key="idx" >◆ {{ child }}</p>
              </div>
              <img :src="item.img_url" class="object-contain h-auto max-w-full mx-auto">
              <div class="item-content leading-loose px-3">
                <div>
                  <p class="text-lg font-semibold text-gray-dark">{{ item.label }}</p>
                  <ul class="font-semibold">
                    <li v-if="item.grade">．適用程度：{{ item.grade }}</li>
                    <li v-if="item.people">．適用族群：{{ item.people }}</li>
                    <li v-else>．統測、學測必備，專家編寫，考題命中率超高！<br/>
                      ． STEAM跨域學習，搭上最火教育趨勢！
                      </li>
                    <li>◆ 學習目標：<br/>{{ item.target }}</li>
                  </ul>
                  <img src="~@/assets/images/double10_2021/shop.png" class="object-contain h-auto w-full max-w-full mx-auto mt-2">
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- 訂閱活動方案 -->
      <div class="pink-light">
        <img src="~@/assets/images/double10_2021/C2_03.png" class="object-contain h-auto max-w-full mx-auto">
      </div>
      <!-- 下殺五折 -->
      <div class="pink-light flex justify-end w-full relative line-left">
        <img src="~@/assets/images/double10_2021/C2_05.png" class="object-contain h-auto max-w-full">
      </div>
      <!-- 現實狂歡特價990 -->
      <div class="pink-light w-full md:flex justify-center px-3">
        <div class="">
          <img src="~@/assets/images/double10_2021/C2_08.png" class="object-contain h-auto max-w-full block">
        </div>
        <div class="">
          <img src="~@/assets/images/double10_2021/C2_09.png" class="object-contain h-auto max-w-full block">
        </div>
      </div>
      <!-- 精選好禮6選1 label -->
      <div class="pink-light flex justify-start w-full relative line-right px-3 py-5">
        <img src="~@/assets/images/double10_2021/gift_03.png" class="object-contain h-auto max-w-full">
      </div>
      <!-- 精選好禮6選1 content -->
      <div class="px-3 md:px-10 text-gray">
        <ul class="text-lg md:text-xl lg:text-2xl leading-loose font-semibold text-gray-dark whitespace-pre-wrap">
          <li><span class="text-pink text-3xl mr-1">❶</span> <mark class="yellow">典藏雜誌6期 (6刊選1)</mark><span class="ml-5 whitespace-no-wrap">(最高價值1,320元)</span><br/><span class="border-b-2 border-gray-800">*注意事項：可指定其他刊別雜誌，不得指定期數。</span></li>
          <li><span class="text-pink text-3xl mr-1">❷</span> <mark class="yellow">你一定要會的英語發音規則</mark><span class="ml-5 whitespace-no-wrap">(價值299元)</span></li>
          <li><span class="text-pink text-3xl mr-1">❸</span> <mark class="yellow">英語模擬城市 生活英語必學會話</mark><span class="ml-5 whitespace-no-wrap">(價值299元)</span></li>
          <li><span class="text-pink text-3xl mr-1">❹</span> <mark class="yellow">和全球做生意 商務職場必備詞彙+實用句</mark><span class="ml-5 whitespace-no-wrap">(價值299元)</span></li>
          <li><span class="text-pink text-3xl mr-1">❺</span> <mark class="yellow">你最需要的日語基礎文法課</mark><span class="ml-5 whitespace-no-wrap">(價值299元)</span></li>
          <li><span class="text-pink text-3xl mr-1">❻</span> <mark class="yellow"> How It Works知識大圖解年度特刊 太空奧祕大圖解</mark><span class="ml-5 whitespace-no-wrap">(價值350元)</span></li>
        </ul>
      </div>
      <!-- 精選好禮6選1 img -->
      <div class="pink-light w-full px-3 md:px-10">
        <img src="~@/assets/images/double10_2021/gift_07.png" class="object-contain h-auto w-full mx-auto">
      </div>
      <!-- 贈品數量有限送完為止 -->
      <div class="px-3 mb-4 py-3 md:px-12">
        <p class="text-pink font-semibold lg:text-lg">＊贈品數量有限送完為止，若贈送完畢，以等值贈品替換。本公司保留活動變更及修改的權利。</p>
      </div>

    </div>
    <!-- footer -->
    <div class="pink w-full">
      <router-link :to="{ name: 'sale', params: { category: 'magazine' }, query: { tag: '96' } }" class="intro-img w-full flex justify-start mx-auto max-w-7xl px-3">
        <img src="~@/assets/images/double10_2021/end_02.png" class="object-contain h-auto max-w-full hidden md:block">
        <div class="flex flex-col justify-center items-center">
          <img src="~@/assets/images/double10_2021/end_03.png" class="object-contain h-auto max-w-full block">
          <p class="text-xs text-white">Copyright © 2021 Hebron Soft Limited All Rights Reserved.</p>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Double10_2021',
  metaInfo () {
    return {
      title: '雙10振興月！全民語言in起來',
      titleTemplate: null
    }
  },
  data () {
    return {
      magazine: [
        { name: 'ABC', id: 7246, img_url: require('@/assets/images/double10_2021/abc.png'), award: ['符合108課綱 核心素養教學', '10度榮獲文化部《中小學生優良課外讀物推介》'], label: '打好英語基礎的最佳選擇！', grade: '全民英檢初級', people: '國中小學生～成人，英語初學者', target: '具備基本生活字彙、簡單會話、基礎英語書信能力，相當於國中畢業程度。' },
        { name: 'LIVE', id: 7248, img_url: require('@/assets/images/double10_2021/live.png'), award: ['符合108課綱 核心素養教學'], label: '日常生活實用英語輕鬆學！', grade: '全民英檢中級', people: '國高中生～成人、一般生活英語會話', target: '具備一般生活會話溝通、基本寫作、文章閱讀能力，相當於高中畢業程度。' },
        { name: 'ALL', id: 7250, img_url: require('@/assets/images/double10_2021/all.png'), award: ['符合108課綱 核心素養教學'], label: '閱讀寫作訓練豐富又多元！', grade: '進階英語學習', people: '想要英語再升級的高中生～成人', target: '英語能力日趨成熟，加強聽說寫作能力，相當於大學非英語主修系所畢業。' },
        { name: 'CNN', id: 7252, img_url: require('@/assets/images/double10_2021/cnn.png'), award: ['榮獲行政院金鼎獎《最佳語言學習類雜誌獎》'], label: '官方授權的專業新聞素材！', grade: '專業新聞英語學習', people: '準備出國留學或商務人士', target: '熟悉美國文化與美語口音和常用俚語，熟稔國際新聞大事，用英語社交聊天沒問題。' },
        { name: 'JP', id: 7254, img_url: require('@/assets/images/double10_2021/jp.png'), award: ['互動日本語讀者問卷調查結果滿意度100%'], label: '日籍老師主編內容實用到位！', grade: '基礎～初中級', people: '適用JLPT測驗N5-N3檢定', target: '具備日常生活日文閱讀能力，能聽懂日常會話，基礎日語溝通沒問題。' },
        { name: 'HW', id: 7340, img_url: require('@/assets/images/double10_2021/hiw.png'), award: ['親子團購社團好評推薦 熱烈搶購中！'], label: '一本全家大小都看得懂的科普雜誌！', grade: '', people: '', target: '六大學習知識點—科學新知、環境生態、科技大觀、交痛運輸、歷史回顧、太空探索' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .max-w-7xl {
    max-width: 84rem !important;
  }
  .pink {
    background: #F76D6D;
  }
  .pink-light {
    background: #FFF8E1;
  }
  .text-pink {
    color: #F76D6D;
  }
  .text-gray-dark {
    color: #494949;
  }
  .text-gray {
    color: #716e69;
  }

  .mag-items {
    .list {
      display: grid;
      overflow: hidden;
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: 1fr;
      grid-column-gap: 5px;
      grid-row-gap: 5px;
      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media (max-width: 640px) {
        grid-template-columns: repeat(1, 1fr);
      }

      .award {
        height: 72px;
        @media (max-width: 640px) {
          height: 48px;
        }
        @media (max-width: 425px) {
          height: 80px;
        }
      }
      .textCenter {
        text-align: center;
      }
    }
  }
  .line-left {
    img {
      z-index: 2;
    }
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 90%;
      height: 1px;
      border-bottom: 2px solid #F76D6D;
      border-style: dashed solid;
    }
  }
  .line-right {
    img {
      z-index: 2;
    }
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      width: 90%;
      height: 1px;
      border-bottom: 2px solid #F76D6D;
      border-style: dashed solid;
    }
  }
  mark.yellow {
    background: linear-gradient(transparent 40%,#ffffff00 40%, #FFF7b0 90%,transparent 95%);
    padding: 2px 1px;
    color: #494949;
    border-radius: 10px;
  }
</style>
